import { render, staticRenderFns } from "./PractitionerList.vue?vue&type=template&id=7ecb8cc2&"
import script from "./PractitionerList.vue?vue&type=script&lang=js&"
export * from "./PractitionerList.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports